import {Slider} from '@material-ui/core';
import React from 'react'
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {selectSelectedRmId} from '../../slices/selected';
import {selectUid} from '../../slices/auth';
import {rmMaterialFeedback} from '../../api/student/cv';
import {selectCv} from "../../slices/profile";

export const RmMaterialFeedback = ({materialId, materialPath, competence}) => {
    const {register, handleSubmit, errors, control} = useForm({
        defaultValues: {
            stars: 0,
            comment: ""
        }
    });
    const dispatch = useDispatch();
    const uid = useSelector(selectUid);
    const rmId = useSelector(selectSelectedRmId);
    const {t} = useTranslation();
    const cv = useSelector(selectCv);

    const onSave = (form) => {
        const feedback = {
            stars: form.stars,
            comment: form.comment,
            studentId: uid,
            rmId,
            materialId
        };

        dispatch(openAlert({type: "info", message: t("alert_generic_update")}));
        dispatch(closeDialog());

        // check if all other competences courses are done
        // if yes, pass competence data to CF to add the competence to user cv
        let addCompetence = false;
        if (competence) {
            const userOtherMaterials = (cv?.bg?.materials || []).filter(mat => mat !== materialId);
            const rmCompetenceOtherMaterials = Object.keys(competence.materials || {}).filter(mat => mat !== materialId);

            console.log(userOtherMaterials)
            console.log(rmCompetenceOtherMaterials)


            addCompetence = true;
            rmCompetenceOtherMaterials.forEach(rmCompetence => {
                const found = userOtherMaterials.includes(rmCompetence);
                if (!found) addCompetence = false;
            });
            console.log(addCompetence)
        }

        rmMaterialFeedback(feedback, materialPath, addCompetence ? competence : null)
            .then(() => dispatch(openAlert({type: "success", message: t("alert_cv_updated")})))
            .catch(() => dispatch(openAlert({type: "error", message: t("alert_generic_error")})));
    }

    return (
        <div className="rmMaterialFeedback">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("student_follow_material_value_label")}</div>
                    <Controller
                        name="stars"
                        onChange={(_, data) => data}
                        control={control}
                        rules={{required: true, min: 1, max: 5}}
                        render={(props) => (
                            <Slider
                                {...props}
                                onChange={(_, value) => {
                                    props.onChange(value);
                                }}
                                marks={true}
                                valueLabelDisplay="auto"
                                min={1}
                                max={5}
                                step={1}
                            />
                        )}
                    />
                    {errors.stars && <span className="error">{t("student_follow_material_value_error")}</span>}
                </div>
                <div className="element">
                    <div className="label">{t("student_follow_material_comment_label")}</div>
                    <input
                        name="comment"
                        ref={register()}
                        type="text"
                        placeholder={t("student_follow_material_comment_ph")}
                    />
                </div>
                <input type="submit" value={t("student_follow_material_submit")}/>
            </form>
        </div>
    )
}
